import React from 'react';
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import InfiniteScroll from '../../../Components/InfiniteScrollComponent';
import Images from '../../../Utils/images';
import { formattedDate } from '../../../Utils/helperFns';
import NoData from '../../../Components/Nodata';
import { ROUTES } from '../../../helpers/contants';
import TablePagination from '../../../Components/Pagination';
import TableLoader from '../../Dashboard/components/SkeletonLoader/TableLoader';
import ProductionCardNew from '../../../Components/ProductionCardNew';
import { updatePaginationPage } from '../../../redux/commonSlice';

const Productions = ({
  isTabular,
  loading,
  favorites,
  handleDetailRedirection,
  navigate,
  hasMore,
  loadMore,
  setFilter,
  count,
  filter,
  showLocationCount,
  permissions,
  allowEditOnScreen,
}: any) => {
  return (
    <>
      {' '}
      {isTabular ? (
        !loading ? (
          favorites && Array.isArray(favorites) && favorites.length > 0 ? (
            <TableContainer className="reelTable table_height sm-table mb-24">
              <Table stickyHeader aria-label="table" className="reelTable">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Image & Production Name</TableCell>
                    <TableCell align="left">Date</TableCell>
                    <TableCell align="left">Type</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(favorites.length > 4 ? favorites : favorites).map(
                    (item: any, index: number) => {
                      const { image, schedule, name, type, _id } = item;
                      const imageUrl =
                        image?.imageUrl ||
                        (typeof image === 'string' ? image : '') ||
                        item?.fallbackImage ||
                        Images.VENDOR_PLACEHOLDER;

                      return (
                        <TableRow key={_id}>
                          <TableCell
                            component="td"
                            align="left"
                            sx={{ cursor: 'pointer' }}
                            onClick={() => handleDetailRedirection(item)}
                          >
                            <div className="d-flex align-center table-name">
                              <img
                                src={imageUrl}
                                alt={name}
                                className="table-thumb mr-8"
                              />
                              {name}
                            </div>
                          </TableCell>

                          <TableCell component="td" align="left">
                            {schedule?.length ? formattedDate(schedule) : '-'}
                          </TableCell>

                          <TableCell component="td" align="left">
                            <span className="type no-border" key={index}>
                              {type}
                            </span>
                          </TableCell>

                          <TableCell component="td" align="center">
                            <IconButton
                              disabled={
                                permissions
                                  ? !permissions?.canEdit('allProduction') ||
                                    !allowEditOnScreen ||
                                    item?.isEditable === false
                                  : !allowEditOnScreen ||
                                    item?.isEditable === false
                              }
                              onClick={() => {
                                navigate(`${ROUTES.CREATE_PRODUCTION}/${_id}`);
                              }}
                            >
                              <i className="edit-grey-icon"></i>
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    },
                  )}
                </TableBody>
              </Table>

              {favorites.length && count > 8 ? (
                <TablePagination
                  limit={8}
                  totalRecords={count}
                  listData={favorites}
                  setPageChange={(val: number) => {
                    updatePaginationPage(val);
                    setFilter({
                      ...filter,
                      page: val,
                    });
                  }}
                />
              ) : null}
            </TableContainer>
          ) : (
            // ✅ Show NoData outside of the table when there are no results
            <div className="no-data-wrapper">
              <NoData className="detail-no-record" title="No project Found" />
            </div>
          )
        ) : (
          <TableLoader />
        )
      ) : (
        <InfiniteScroll
          isLoading={loading}
          noData={!loading && !favorites?.length}
          hasMore={hasMore}
          onLoadMore={loadMore}
          className="with-title"
          isShowNoData
          title="No project Found"
        >
          <>
            {favorites?.length > 0 ? (
              <div className="prod_card_container">
                {favorites?.map((item: any, index: number) => (
                  <>
                    <ProductionCardNew
                      handleDetailRedirection={handleDetailRedirection}
                      key={item._id || item?.fallbackImage || index}
                      id={item._id}
                      isEpisodeDashboard
                      image={
                        item?.image && item?.image.trim() !== ''
                          ? item?.image || item?.fallbackImage
                          : item?.fallbackImage || Images.VENDOR_PLACEHOLDER
                      }
                      details={
                        item?.schedule?.length
                          ? formattedDate(item?.schedule)
                          : null
                      }
                      showLocationCount={showLocationCount}
                      heading={item?.name}
                      type="Production"
                      status={item?.type}
                      location={item?.locationPurpose}
                      buttonText={'View Dashboard'}
                      item={item}
                      showEditIcon
                      onEditClick={() => {
                        navigate(`${ROUTES.CREATE_PRODUCTION}/${item?._id}`);
                      }}
                      isEditDisabled={
                        permissions
                          ? !permissions?.canEdit('allProduction') ||
                            !allowEditOnScreen ||
                            item?.isEditable === false
                          : !allowEditOnScreen || item?.isEditable === false
                      }
                    />
                  </>
                ))}
              </div>
            ) : null}
          </>
        </InfiniteScroll>
      )}
    </>
  );
};

export default Productions;
